import React from 'react';
import { Helmet } from 'react-helmet-async';

const About = ({ isHome }) => {


  return (
    <>
      {!isHome && (
        <Helmet>
          <title>À propos – Cabinet Dentaire Temara</title>
          <meta
            name="description"
            content="Découvrez l'équipe et l'expertise du Dr Lachhab au Cabinet Dentaire Temara, pour des soins dentaires de qualité."
          />
          <meta
            property="og:title"
            content="À propos – Cabinet Dentaire Temara"
          />
          <meta
            property="og:description"
            content="Apprenez à connaître notre équipe et notre cabinet dentaire à Temara."
          />
          <meta
            property="og:image"
            content="https://centredentairetemara.ma/images/logo_horizontal_no_background.png"
          />
          <meta
            property="og:url"
            content="https://centredentairetemara.ma/about"
          />
          <meta property="og:type" content="website" />
        </Helmet>
      )}

      <section id="about" className="section-padding bg-white pt-24">
        <div className="container-custom">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            {/* Left Column - Image */}
            <div className="relative" data-aos="fade-right">
              <div className="bg-gradient-to-br from-primary-100 to-secondary-100 rounded-2xl p-8">
                <div className="bg-white rounded-xl p-6 shadow-lg">
                  <div className="aspect-w-16 aspect-h-9 bg-gray-200 rounded-lg flex items-center justify-center">
                    <img
                      src="/images/cabinet.jpg"
                      alt="Modern Dental Clinic"
                      className="w-full h-full object-cover rounded-lg"
                    />
                  </div>
                </div>
              </div>
            </div>

            {/* Colonne de droite - Contenu */}
            <div data-aos="fade-left">
              <h2 className="text-4xl font-bold text-gray-800 mb-6">
                À propos de <span className="text-gradient">Notre Cabinet</span>
              </h2>

              <p className="text-lg text-gray-600 mb-6 leading-relaxed">
                Au cabinet dentaire du Dr LACHHAB YOUSSEF, situé au cœur de
                Témara, nous mettons tout en œuvre pour offrir à nos patients le
                sourire qu'ils ont toujours souhaité.
              </p>

              {/* Déclaration de mission */}
              <div className="bg-gradient-to-r from-primary-50 to-secondary-50 rounded-xl p-6 mb-8">
                <p className="text-gray-700">
                  <span className="font-semibold">
                    ● 🌟 Équipe expérimentée{" "}
                  </span>
                  : Des dentistes spécialisés pour chaque besoin.
                </p>

                <p className="text-gray-700">
                  <span className="font-semibold">
                    ● 🏥 Technologie de pointe{" "}
                  </span>
                  : Équipements modernes pour des soins précis.
                </p>
                <p className="text-gray-700">
                  <span className="font-semibold">
                    ● 🕒 Prise de rendez-vous rapide{" "}
                  </span>
                  : Flexibilité pour s’adapter à votre emploi du temps.
                </p>
                <p className="text-gray-700">
                  <span className="font-semibold">
                    ● 😊 Ambiance conviviale{" "}
                  </span>
                  : Un espace pensé pour vous mettre à l’aise.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default About; 